import axios from '@/api/$axios'
export default {
  list ({ teacherId, page, perPage }) {
    return axios.get(`/teachers/${teacherId}/fonts`, {
      params: {
        page, perPage
      }
    })
  },
  detail ({ id }) {
    return axios.get(`/fonts/${id}`)
  },
  check ({ id, text }) {
    return axios.post(`/fonts/${id}/check_unavailable`, {
      text
    })
  }
}
